import API_ROUTES from "../constants/api";
import HttpUtil from "../http-handler/http-util";

export default class DmsService {
  static createFolder(params) {
    return HttpUtil.post(API_ROUTES.DMS.CREATEFOLDER, params);
  }
  static getSubFolders(params) {
    return HttpUtil.post(API_ROUTES.DMS.GETSUBFOLDERS, params);
  }
  static getRootFolders(companyId) {
    return HttpUtil.get(
      API_ROUTES.DMS.GETROOTFOLDERS.replace("<companyId>", companyId)
    );
  }
  static deleteFolder(params) {
    return HttpUtil.delete(API_ROUTES.DMS.DELETEFOLDER, params);
  }
  static getRegulationDoc(regId, parentId) {
    if (parentId) {
      return HttpUtil.get(
        API_ROUTES.DMS.REGULATIONDOC.replace("<regId>", regId).replace(
          "<typeId>",
          parentId
        )
      );
    } else {
      return HttpUtil.get(
        API_ROUTES.DMS.REGULATIONDOC.replace("<regId>", regId).replace(
          "?typeId=<typeId>",
          ""
        )
      );
    }
  }
  static createRegulationDoc(regId, params) {
    return HttpUtil.post(
      API_ROUTES.DMS.CREATEREGULATIONDOC.replace("<regId>", regId),
      params
    );
  }

  static deleteRegulationDoc(regId, folderId) {
    return HttpUtil.delete(
      API_ROUTES.DMS.DELETEREGULATIONDOC.replace("<regId>", regId).replace(
        "<docId>",
        folderId
      )
    );
  }
  static updateRegulationDoc(regId, folderId, params) {
    return HttpUtil.put(
      API_ROUTES.DMS.UPDATEREGULATIONDOC.replace("<regId>", regId).replace(
        "<docId>",
        folderId
      ),
      params
    );
  }
  static getFolderContent(containerId) {
    return HttpUtil.get(
      API_ROUTES.DMS.GETFOLDERCONTENT.replace("<containerId>", containerId)
    );
  }
  static deleteDocument(documentId) {
    return HttpUtil.delete(
      API_ROUTES.DMS.DELETEDOCUMENT.replace("<documentId>", documentId)
    );
  }
  static createDocument(params) {
    return HttpUtil.post(API_ROUTES.DMS.CREATEDOCUMENT, params);
  }
  static renameDocument(documentId, documentName) {
    return HttpUtil.patch(
      API_ROUTES.DMS.RENAMEDOCUMENT.replace("<documentId>", documentId).replace(
        "<documentName>",
        documentName
      )
    );
  }
  static getDocumentsSharedWithSupplier(userId, containerId) {
    return HttpUtil.get(
      API_ROUTES.DMS.GETDOCUMENTSHAREDWITHUSER.replace(
        "<containerId>",
        containerId
      ).replace("<sharedWithId>", userId)
    );
  }
  static getDocumentSharedByCompany(companyId, regulationId) {
    return HttpUtil.get(
      API_ROUTES.DMS.GETDOCUMENTSSHAREDBYCOMPANY.replace(
        "<sharedById>",
        companyId
      ).replace("<regId>", regulationId)
    );
  }
  static getFolderContentByCompany(companyId, regulationId, containerId) {
    return HttpUtil.get(
      API_ROUTES.DMS.GETFOLDERCONTENTBYCOMPANY.replace("<containerId>", containerId)
        .replace("<sharedById>", companyId)
        .replace("<regId>", regulationId)
    );
  }
}
